/** @format */

import React, { useState } from 'react'
import styled from 'styled-components'
import { Dialog, Input, Message, Tip } from '@king-design/react'
import { TriggerRecordItemProp } from '../container'
import { deleteTrigger } from 'src/api/ApiEventOpsTrigger'

interface DeleteRuleDialogProps {
  className?: string
  visible: boolean
  record: TriggerRecordItemProp
  onClose: (update?: boolean) => void
}

const DeleteRuleDialog: React.FC<DeleteRuleDialogProps> = ({
  className,
  visible,
  record,
  onClose
}) => {
  const [confirmName, setConfirmName] = useState<string>('')

  const onDeleteTrigger = async () => {
    const result = await deleteTrigger({
      Sign: record.Sign
    })
    if (result) {
      Message.success('删除成功')
      onClose(true)
      setConfirmName('')
    }
  }

  return (
    <Dialog
      value={visible}
      width={500}
      title="确认删除"
      onChangeValue={show => {
        if (!show) {
          onClose()
          setConfirmName('')
        }
      }}
      disabledOk={confirmName !== record?.Name}
      ok={onDeleteTrigger}
    >
      {record ? (
        <div className={className}>
          <Tip type="warning" showIcon>
            将删除规则数据，且不可恢复！删除前确保触发器已被停用，且没有正在审批中的记录
          </Tip>
          <div className="ksc-space">
            请输入触发器名称
            <b>{record.Name}</b>
            进行删除确认
            <Input
              placeholder={record.Name}
              value={confirmName}
              onChangeValue={value => {
                setConfirmName(value)
              }}
            />
          </div>
        </div>
      ) : null}
    </Dialog>
  )
}

export default styled(DeleteRuleDialog)`
  .ksc-space {
    text-align: center;
    margin-top: 16px;
    padding-left: 38px;
    .k-input {
      margin-top: 16px;
    }
  }
`
